import * as React from "react"
import * as Immutable from "immutable";
import { RentalAdvert } from "../../../types/types";
import { averageRating } from "../../../utils/guestbook_entry";
import { FormattedNumber } from "react-intl";

type Props = {
  rental_advert: RentalAdvert
}

export const RentalAdvertSnippet = (props: Props) : JSX.Element => (
  <div>
    <article className="accommodation">
      <div className="box box--horizontal">
        <a href={props.rental_advert.path} title={props.rental_advert.objectName} className="box__inner">
        <div className="box__cell">
          <div className="box__visual" style={props.rental_advert.overviewImage ? {backgroundImage: `url(${props.rental_advert.overviewImage.url})`} : {}}>
            {
              props.rental_advert.overviewImage ?
                <img src={props.rental_advert.overviewImage.url} />
              : ''
            }
            <div className="box__overlay box__overlay--hover">
              <div className="box__overlay-wrapper">
                <div className="box__overlay-inner">
                  {
                    props.rental_advert.lastMinuteOffers.nodes.length > 0 ?
                      <div className="last-minute-wrapper">LAST MINUTE</div>
                    : ''
                  }

                  <h3 className="box__title">
                    {props.rental_advert.objectName}
                  </h3>
                  <div className="box__subtitle">
                    {props.rental_advert.city && props.rental_advert.city.name}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="box__cell box__body">
          <div dangerouslySetInnerHTML={{__html: props.rental_advert.priceForOverview}} />
          <ul className="iconbar iconbar--accommodation">
            <li className="iconbar__item icon-persons" title={I18n.t('search.info.upto_people', { count: props.rental_advert.maxPersons })}>
              <div className="iconbar__count">
                {props.rental_advert.maxPersons}
              </div>
            </li>
            {
              props.rental_advert.isStudio ?
                <li className="iconbar__item icon-room" title={I18n.t('search.info.studio')}>
                  <div className="iconbar__count">
                    {I18n.t('search.info.studio')}
                  </div>
                </li>
              :
              <li className="iconbar__item icon-room" title={I18n.t('search.info.bedrooms', { count: props.rental_advert.bedrooms })}>
                <div className="iconbar__count">
                  {props.rental_advert.bedrooms}
                </div>
              </li>
            }

            <li className="iconbar__item icon-bath" title={I18n.t('search.info.bathrooms', { count: props.rental_advert.bathrooms })}>
              <div className="iconbar__count">
                {props.rental_advert.bathrooms}
              </div>
            </li>
          </ul>
          {
            props.rental_advert.displayGuestbookEntries.nodes.length > 0 ?
              <div className="rating rating--bt" itemProp="aggregateRating" itemScope={true} itemType="http://schema.org/AggregateRating">
                <meta content="<%= rateable.count %>" itemProp="reviewCount" />
                <div className="rating__count">
                  {I18n.t('search.recension', { count: props.rental_advert.displayGuestbookEntries.nodes.length })}
                </div>
                <div className="rating__average" itemProp="ratingValue">
                  <FormattedNumber
                    value={averageRating(Immutable.List(props.rental_advert.displayGuestbookEntries.nodes))}
                    minimumFractionDigits={1}
                    maximumFractionDigits={1}
                  />

                </div>
              </div>
            : <div className="rating rating--bt">
                <div className="rating__count">&nbsp;</div>
              </div>
          }
        </div>
        </a>
      </div>
    </article>
  </div>
)
